import type { NewsletterContent } from '@mawkaa/types';
import { Mail, Send } from 'lucide-react';

interface NewsletterBlockProps {
  content: NewsletterContent;
  isEditing?: boolean;
}

export function NewsletterBlock({ content, isEditing }: NewsletterBlockProps) {
  const {
    title = 'Restez informé',
    subtitle = 'Inscrivez-vous à notre newsletter pour recevoir nos dernières actualités',
    placeholder = 'Votre adresse email',
    buttonText = 'S\'inscrire',
    style = 'inline',
  } = content;

  const isStacked = style === 'stacked';

  return (
    <section className="px-4 py-16 bg-primary/5">
      <div className="max-w-2xl mx-auto text-center">
        <Mail className="w-12 h-12 mx-auto text-primary mb-4" />
        <h2 className="text-3xl font-bold mb-3">{title}</h2>
        <p className="text-muted-foreground mb-8">{subtitle}</p>

        <form
          className={`${isStacked ? 'space-y-4' : 'flex gap-3'} max-w-md mx-auto`}
          data-newsletter-form
          onSubmit={(e) => e.preventDefault()}
        >
          <input
            type="email"
            name="email"
            placeholder={placeholder}
            required
            className={`${
              isStacked ? 'w-full' : 'flex-1'
            } px-5 py-4 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary`}
          />
          <button
            type="submit"
            className={`${
              isStacked ? 'w-full' : ''
            } px-8 py-4 bg-primary text-white rounded-xl font-medium hover:bg-primary/90 transition-colors flex items-center justify-center gap-2`}
          >
            <span>{buttonText}</span>
            <Send className="w-4 h-4" />
          </button>
        </form>

        <p className="text-xs text-muted-foreground mt-4">
          En vous inscrivant, vous acceptez notre politique de confidentialité.
        </p>
      </div>
    </section>
  );
}
